export enum PatientStatus {
    Zuordnung = 'z',
    KeineZuordnung = 'k',
    Gefunden = 'j',
    NichtGefunden = 'n',
    NichtGesucht = 'x',
    Unklar = 'u',
}
